<template>
  <div class="stat-indicator">
    <div class="stat-indicator-ring" :style="box">
      <svg v-if="showRing" :width="size" :height="size" class="stat-indicator-svg-rot">
        <circle :cx="size/2" :cy="size/2" :r="r" :stroke="trackColor" :stroke-width="stroke" fill="none"/>
        <circle :cx="size/2" :cy="size/2" :r="r" :stroke="ringColor" :stroke-width="stroke" fill="none"
                :stroke-dasharray="dashArray" :stroke-dashoffset="dashOffset" stroke-linecap="round" class="stat-indicator-ring-anim"/>
      </svg>
      <div v-if="showSquare" class="stat-indicator-square" :style="`height: ${size * 0.8}px; width: ${size * 1.1}px`"></div>
      <div class="stat-indicator-center">{{ centerText_computed }}{{ suffix }}</div>
    </div>
    <span class="stat-indicator-label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'StatIndicator',
  props: {
    value: { type: Number, default: 0 },
    centerText: { type: Number, default: 0 },
    label: { type: String, default: '' },
    size: { type: Number, default: 50 },
    stroke: { type: Number, default: 2.5 },
    trackColor: { type: String, default: '#f5f5f5' },
    ringColor: { type: String, default: '#f50537' },
    showRing: { type: Boolean, default: true },
    showSquare: { type: Boolean, default: false },
    decimalPlaces: { type: Number, default: 1 },
    isPercentage: { type: Boolean, default: false },
    suffix: { type: String, default: '' },
  },
  computed: {
    value_computed() {
      // if(!this.value) return null;
      if(this.isPercentage) return (this.value * 100);
      return this.value;
    },
    centerText_computed() {
      // if(!this.centerText) return null;
      if(this.isPercentage) return Number((this.centerText * 100).toFixed(this.decimalPlaces));
      return Number(this.centerText.toFixed(this.decimalPlaces));
    },
    r(){ 
      return (this.size/2)-this.stroke; 
    },
    c() { 
      return 2*Math.PI*this.r; 
    },
    dashArray(){ 
      return this.c; 
    },
    dashOffset(){
      const v=Math.max(0,Math.min(100,this.value_computed));
      return this.c*(100-v)/100;
    },
    box() { 
      return { width:this.size+'px', height:this.size+'px' }; 
    }
  },
}
</script>

<style scoped>
.stat-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .35rem;
  min-width: 80px;
}

.stat-indicator-ring {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-indicator-svg-rot {
  transform: rotate(-90deg);
}

.stat-indicator-ring-anim {
  transition: stroke-dashoffset 1s ease-out, stroke .2s ease;
}

.stat-indicator-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 1rem; */
  font-weight: 600;
  color: #333;
}

.stat-indicator-label {
  /* font-size: 1rem; */
  color: #666;
  text-align: center;
  margin-top: .15rem;
}

.stat-indicator:hover .stat-indicator-center,
.stat-indicator:hover .stat-indicator-label {
  color: var(--color-primary);
}

.stat-indicator .stat-indicator-ring:hover {
  transform: scale(1.08);
  transition: transform .2s;
}
.stat-indicator-square {
  background: rgb(250, 250, 250);
  border: 2px solid lightgray;
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// StatIndicator.vue?301cd924